import { camelizeKeys } from 'humps';

class RoutesApi {
  async calculateAndValidate(routeOrdersToCalculateArrivedTime) {
    const response = await fetch(`/admin/routes/calculate-and-validate`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      body: JSON.stringify({
        routeOrdersToCalculateArrivedTime
      })
    });

    return camelizeKeys(await response.json());
  }

  async calculate(routeOrdersToCalculateArrivedTime) {
    const response = await fetch(`/admin/routes/calculate`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      body: JSON.stringify({
        routeOrdersToCalculateArrivedTime
      })
    });

    return camelizeKeys(await response.json());
  }
}

export const routesApi = new RoutesApi();
